module.exports = __webpack_public_path__ + "static/media/bookingList.81569710.svg";